// removed by extract-text-webpack-plugin
module.exports = {"error":"style__error___37AA0","error-list":"style__error-list___lfg4F"};


//////////////////
// WEBPACK FOOTER
// ./components/InlineError/style.scss
// module id = 1212
// module chunks = 0